import { fromJS } from 'immutable';

import generateHandleActions from 'redux/state-handler';
import {
  FORGOT_PASSWORD,
  LOGIN,
  REFRESH_TOKEN,
  LOGIN_ORGANIZATION,
  RESET_PASSWORD,
  SIGNUP,
  UPDATE_PROFILE,
  UPLOAD_COVER_IMAGE,
  UPLOAD_LICENSE_IMAGE,
  UPLOAD_LOGO,
  BUYERS_PAYMENT_DETAIL,
  VERIFY_EMAIL,
} from 'redux/constants';

const apiStates = [
  { type: FORGOT_PASSWORD, name: 'sendNewPasswordLink' },
  { type: LOGIN, name: 'tokenInfo' },
  { type: REFRESH_TOKEN, name: 'tokenInfo' },
  { type: LOGIN_ORGANIZATION, name: 'tokenInfo' },
  { type: RESET_PASSWORD, name: 'resetPassword' },
  { type: SIGNUP, name: 'tokenInfo' },
  { type: UPDATE_PROFILE, name: 'tokenInfo' },
  { type: UPLOAD_COVER_IMAGE, name: 'tokenInfo' },
  { type: UPLOAD_LICENSE_IMAGE, name: 'tokenInfo' },
  { type: UPLOAD_LOGO, name: 'tokenInfo' },
  { type: VERIFY_EMAIL, name: 'emailVerification' },
];
const instantStates = [];
const storage = {
  tokenInfo: 'tokenInfo',
};
const listValues = [];

const updatePaymentDetail = (state, { payload: { data } }) =>
  state.setIn(['tokenInfo', 'data', 'user', 'account', 'paymentDetail'], fromJS(data));
const customHandlers = {
  [`${BUYERS_PAYMENT_DETAIL}_CREATE_SUCCESS`]: updatePaymentDetail,
  [`${BUYERS_PAYMENT_DETAIL}_UPDATE_SUCCESS`]: updatePaymentDetail,
  [`${BUYERS_PAYMENT_DETAIL}_REMOVE_SUCCESS`]: updatePaymentDetail,
};

export default generateHandleActions({
  apiStates, instantStates, storage, listValues, customHandlers,
});
